export default "__VITE_ASSET__52112966__"